import React from "react";
import { Card, CardBody, UncontrolledTooltip } from "reactstrap";
import { getBadgeIcon, getBadgeColor, getCategoryGradient } from "./../../../helper/badgeIconHelper.js";

class BadgeCard extends React.Component {

  render() {

    const { badge, size } = this.props;
    const isSmall = size === 'sm';
    const iconSize = isSmall ? '2rem' : '3rem';
    const cardPadding = isSmall ? '0.5rem' : '1rem';

    var icon = getBadgeIcon(badge);
    var color = getBadgeColor(badge);
    var gradient = getCategoryGradient(badge.category);

    return (
      <Card
        className="shadow-sm text-center mb-2"
        style={{ cursor: 'pointer', transition: 'transform 0.2s', minWidth: isSmall ? '80px' : '120px' }}
        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
        onClick={() => this.props.onClick && this.props.onClick(badge)}
        id={'badge-' + badge.id}
      >
        <CardBody style={{ padding: cardPadding }}>
          <div
            className="rounded-circle d-inline-flex align-items-center justify-content-center mb-2"
            style={{
              width: isSmall ? '50px' : '70px',
              height: isSmall ? '50px' : '70px',
              background: gradient,
              border: '3px solid ' + color,
              boxShadow: '0 4px 12px ' + color + '40'
            }}
          >
            <i
              className={icon}
              style={{ fontSize: iconSize, color: '#fff', textShadow: '0 1px 3px rgba(0,0,0,0.2)' }}
            />
          </div>
          {!isSmall && (
            <React.Fragment>
              <h5 className="mb-1" style={{ fontSize: '0.85rem', fontWeight: 600 }}>
                {badge.badgeName || badge.name}
              </h5>
              {badge.score > 0 && (
                <span className="badge badge-primary badge-pill" style={{ fontSize: '0.7rem' }}>
                  {badge.score} pts
                </span>
              )}
            </React.Fragment>
          )}
        </CardBody>
        <UncontrolledTooltip target={'badge-' + badge.id} placement="top">
          {badge.badgeDescription || badge.description || badge.badgeName || badge.name}
        </UncontrolledTooltip>
      </Card>
    );

  }

}

export default BadgeCard;
